var _style, _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmStudioBetaClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 49 27",
    style: {
      enableBackground: "new 0 0 49 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#111111;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.3,5.6c0,0.7-0.6,1.2-1.2,1.2H4.2C3.6,6.9,3,6.3,3,5.6V2.1c0-0.7,0.6-1.2,1.2-1.2H18c0.7,0,1.2,0.5,1.2,1.2 V5.6z M12.4,23.1H9.9v-8.6h2.6V23.1z M20.1,3.4V2.1C20.1,0.9,19.2,0,18,0H4.2C3.1,0,2.1,0.9,2.1,2.1v1.3H1.8C0.8,3.4,0,4.2,0,5.2 v2.9c0,1,0.8,1.8,1.8,1.8h7.4l0.7,0c0.5,0,0.9,0.4,0.9,0.9v2.9H9V24h4.3V13.7h-1.7v-2.9c0-1-0.8-1.8-1.8-1.8H8.8h-7 C1.3,9,0.9,8.6,0.9,8.1V5.2c0-0.5,0.4-0.9,0.9-0.9h0.4v1.3c0,1.2,0.9,2.1,2.1,2.1H18c1.2,0,2.1-0.9,2.1-2.1V4.3H21V3.4H20.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11.9,
    className: "st0",
    width: 34,
    height: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.5,15.5h2.9c0.3,0,0.7,0,1,0.1c0.3,0,0.6,0.1,0.9,0.3c0.3,0.1,0.5,0.3,0.7,0.6c0.2,0.3,0.3,0.6,0.3,1 c0,0.4-0.1,0.8-0.4,1.1c-0.2,0.3-0.6,0.5-1,0.6v0c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.2,0.5,0.4s0.3,0.4,0.3,0.6 c0.1,0.2,0.1,0.5,0.1,0.7c0,0.4-0.1,0.8-0.3,1c-0.2,0.3-0.4,0.5-0.7,0.7c-0.3,0.2-0.6,0.3-0.9,0.4s-0.7,0.1-1,0.1h-3.2V15.5z  M21.3,18.6h1.2c0.1,0,0.3,0,0.4,0c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.2,0-0.3-0.1-0.4 c-0.1-0.1-0.2-0.2-0.3-0.2S23,17.1,22.8,17c-0.1,0-0.3,0-0.4,0h-1.2V18.6z M21.3,21.9h1.5c0.1,0,0.3,0,0.4,0c0.1,0,0.3-0.1,0.4-0.2 c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.3-0.3s-0.3-0.1-0.5-0.1 c-0.2,0-0.3,0-0.5,0h-1.3V21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.7,15.5H32v1.6h-3.6v1.5h3.4v1.6h-3.4v1.6h3.8v1.6h-5.5V15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.1,17.1h-2.2v-1.5H39v1.5h-2.2v6.3h-1.7V17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.5,15.5h1.4l3.4,7.8h-1.9l-0.7-1.6h-3L40,23.3h-1.9L41.5,15.5z M42.1,17.8l-0.9,2.4h1.9L42.1,17.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmStudioBetaClicked);
export default __webpack_public_path__ + "static/media/tm_studio_beta_clicked.6f94b9408def7eeb8e3e7c514af01cc7.svg";
export { ForwardRef as ReactComponent };